const page = require('../../../../../components/page/page')
const saleDeletedDt = require('./saleDeleted-dt')
import saleDeletedPage from './saleDeleted-page.html'

let HTMLwasSelected = false

function HTMLselect() {
  document.body.insertAdjacentHTML('beforeend', saleDeletedPage)
  HTMLwasSelected = true
}

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect()
  if (detail.act === 'show') {
    page.start(detail)
    saleDeletedDt.start({ dest: 'saleDeleted', elem: 'dt', act: 'select', entity: 'saleDeleted' })
  }
}

